import React from "react";
import styles from "./DefaultText.module.scss";

const DefaultText = ({ isOnboadedTryon }) => {
	return (
		<>
			<span className={styles.swanCta}>
				<span className={styles.swanCta__text}>
					<span className={`${styles.swanCta__textBlack} ${styles.swanCta__noUnderline}`}>{isOnboadedTryon ? "Try-On" : "Size"} with</span>
					<span className={`${styles.swanCta__textBlue} ${styles.swanCta__spaceLeft}`} >Swan</span>
				</span>
			</span>
		</>
	);
};

export default DefaultText;
